module.exports = __webpack_public_path__ + "img/code.185c1ac1.png";